<template>
    <div class="widget" :class="{ 'is-loading': isLoading }">
        <h3>Notificaties</h3>

        <div class="widget__inner">
            <ul>
                <li v-for="notification in latestNotifications" :key="notification.id">
                    <span>{{ notification.message }}</span>
                    <time :datetime="notification.created_at">{{ notification.created_at | formatDateTime }}</time>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
	import moment from 'moment-timezone'
	import { mapGetters } from 'vuex'
	import { FETCH_LATEST_NOTIFICATIONS } from '@/store/modules/widgets'

	export default {
		data () {
			return {
				isLoading: true,
			}
		},

		computed: {
			...mapGetters([
				'latestNotifications',
			]),
		},

		filters: {
			formatDateTime (value) {
				return value ? moment(value).locale('nl').format('D MMM YYYY, HH:mm') : ''
			},
		},

		mounted () {
			this.fetchData()
		},

		methods: {
			fetchData () {
				this.$store.dispatch(FETCH_LATEST_NOTIFICATIONS).then(() => {
					this.isLoading = false
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
    ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 0;
            border-bottom: 1px solid #e6e6e6;

            p {
                margin-bottom: 0;
            }

            strong {
                font-size: 22px;
            }

            time {
                flex-shrink: 0;
                margin-left: 20px;
                font-size: 14px;
                white-space: nowrap;
                color: rgba(48, 62, 73, .4);
            }

            &:first-child {
                padding-top: 0;
            }
        }
    }
</style>